import { render, staticRenderFns } from "./FacebookConnect.vue?vue&type=template&id=0bd918e2&scoped=true&"
import script from "./FacebookConnect.vue?vue&type=script&lang=js&"
export * from "./FacebookConnect.vue?vue&type=script&lang=js&"
import style0 from "./FacebookConnect.vue?vue&type=style&index=0&id=0bd918e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd918e2",
  null
  
)

export default component.exports